/**
 * Parsing orari da configuratore (ORARIOPRODPANE, ORARIOBLOCCO, ORARIOSBLOCCO).
 * Allineato a Planning.js / AdminSettings.
 */

export const parseConfiguratorTimeToMinutes = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number' && !Number.isNaN(value)) {
    const ore = Math.floor(value);
    const parteDecimale = value - ore;
    const minuti = Math.round(parteDecimale * 100);
    return ore * 60 + (minuti >= 60 ? minuti % 60 : minuti);
  }
  const orarioString = String(value).replace(/[,:]/g, '.');
  if (!orarioString.trim()) return null;
  let restrictionHour = 0;
  let restrictionMinute = 0;
  if (orarioString.includes('.')) {
    const partsStr = orarioString.split('.');
    restrictionHour = parseInt(partsStr[0], 10);
    if (Number.isNaN(restrictionHour)) return null;
    let minPart = partsStr[1];
    if (minPart && minPart.length === 1) {
      minPart = `${minPart}0`;
    }
    restrictionMinute = parseInt(minPart ? minPart.substring(0, 2) : '0', 10);
    if (Number.isNaN(restrictionMinute)) restrictionMinute = 0;
  } else {
    restrictionHour = parseInt(orarioString, 10);
    if (Number.isNaN(restrictionHour)) return null;
  }
  return restrictionHour * 60 + restrictionMinute;
};

const formatMinutesAsClock = (totalMinutes) => {
  const h = Math.floor(totalMinutes / 60) % 24;
  const m = totalMinutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

const EIGHT_AM_MINUTES = 8 * 60;
const NOON_MINUTES = 12 * 60;

/**
 * Override destinazione: true se il cutoff per ordini "domani" è già passato.
 *
 * - Blocco tra 00:00 e 08:00: se l'ora attuale è dopo le 08:00, l'orario di blocco
 *   appartiene al giorno successivo (es. blocco 00:30 alle 22:00 → ancora consentito).
 *   Se l'ora attuale è tra 00:00 e 08:00, confronto diretto nella finestra notturna.
 * - Blocco dopo le 12:00: cutoff del giorno corrente (es. 22:30 blocca da quell'ora).
 * - Blocco tra 08:00 e 12:00: cutoff mattutino del giorno corrente.
 */
export const isDestinationBlockCutoffPassed = (currentTotalMinutes, blockTotalMinutes) => {
  if (
    blockTotalMinutes < EIGHT_AM_MINUTES &&
    currentTotalMinutes >= EIGHT_AM_MINUTES
  ) {
    return false;
  }
  if (blockTotalMinutes > NOON_MINUTES) {
    return currentTotalMinutes >= blockTotalMinutes;
  }
  return currentTotalMinutes >= blockTotalMinutes;
};

export const formatConfiguratorOrarioDisplay = (value) => {
  const mins = parseConfiguratorTimeToMinutes(value);
  if (mins == null) return String(value ?? '');
  return formatMinutesAsClock(mins);
};

/** True se il valore è non vuoto e parsabile come orario configurator (numero, "12.30", "12,30", "12:30", ecc.) */
export const isConfiguratorOrarioValueValid = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  return parseConfiguratorTimeToMinutes(value) != null;
};
